import { ReactNode } from "react";
import styles from "./index.module.scss";

type PropTypes = {
  children: ReactNode | ReactNode[];
};

const ModalActions = ({ children }: PropTypes) => {
  return (
    <>
      <div className={styles.divider} />
      <div className={styles.actions}>{children}</div>
    </>
  );
};

export default ModalActions;
